import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Form, Field } from 'formik';
import Yup from 'yup';
import MainTitle from 'base/components/MainTitle/index';
import SubmitButton from 'base/components/forms/SubmitButton';
import FormikInputField from 'base/components/forms/formik/FormikInputField';
import { createTag } from 'documents/store/tags/actions';
import { closeModal } from 'modal/store/actions';


const CreateTagForm = ({errors, isSubmitting}) => ( // eslint-disable-line
  <Form>
    <Field
      type="text"
      name="name"
      placeholder="Name"
      component={FormikInputField}
      autoFocus
    />
    <SubmitButton type="submit" disabled={isSubmitting}>
        Create Tag
    </SubmitButton>
  </Form>
);


const CreateTagModal = ({
  name, createTag, closeModal,
}) => (
  <>
    <MainTitle withSpaceBelow>New Tag</MainTitle>

    <Formik
      initialValues={{
        name: '',
      }}
      validationSchema={
            Yup.object().shape({
              name: Yup.string()
                .required('Name is required.'),
            })
          }
      render={CreateTagForm}
      onSubmit={(values) => {
        const tag = {
          name: values.name,
        };
        createTag(tag);
        closeModal(name);
      }}
    />
  </>
);
CreateTagModal.propTypes = {
  name: PropTypes.string.isRequired,
  createTag: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  createTag,
  closeModal,
};

export default connect(
  null,
  mapDispatchToProps,
)(CreateTagModal);
